import React, { useEffect, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from "../../../../../../components/icon/iconfont";
import AddToCartContainer from "./addtocart";
import ProductShippingInfo from "./shipping-info";
import ProductDetailAndModel from "./detail-model";
import FeatureModel from "./features-model";
import ProductActivityType from "./activity-type";
import ProductGookToKnow from "./good-to-know";
import ProductSizeInformation from "./product-size";
import ProductColorInformation from "./product-color";
import ProductAppExclusive from "./app-exclusive";
import { ProductOffInfo } from "./product-off-info";
import deeplink from "../../../../../../../utils/deeplink";
import BasicInformation from "./basic-infomation";
import { isFlashSales } from "../../../../../../../utils/product";
import { FormattedMessage } from "react-intl";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { PreOrderComponent } from "../../../../listing/components/item/pre-order-components"


const ProductDiscountBulletinBoard = props => {
    const { discountBulletinBoard } = props;

    const discountBulletinBoardEVent = () => {
        let message = discountBulletinBoard?.message?.replace(/<\/?.+?\/?>/g, "");
        if (window.GeekoSensors) {
            window.GeekoSensors.Track("ELClick", {
                clicks: discountBulletinBoard?.activityId || "",
                activity_type: message || "",
            })
        }
    }


    return <div className={classes.ProductDiscountBulletinBoard}>
        <Iconfont className={classes.Icon}>&#xe6b4;</Iconfont>
        <a href={deeplink(discountBulletinBoard?.deepLink, "pc")} className={classes.HrefItem} onClick={discountBulletinBoardEVent}>
            <span dangerouslySetInnerHTML={{ __html: discountBulletinBoard?.message }}></span>
        </a>
    </div>
}



const RightMessageContainer = props => {
    useStyles(classes);
    const global = useSelector(state => state.global)
    const { productHooks, reviewItem, imagePrefix, changeHoverImage, } = props;
    const { selectedProduct, isBeautyMakeup, productVO, selectedVariant, estimatedPercent } = productHooks;
    const { selectedProductId, serverTime, couponActivity } = productVO
    const { coupons } = selectedVariant?.couponActivity || selectedProduct?.couponActivity || {}
    const { promotionalActivities: promotions } = selectedProduct || {}
    const [showProm, setShowProm] = useState(false) //  活动弹窗

    const isFlash = isFlashSales(selectedProduct)

    const promotionFlash = useMemo(() => {
        if (promotions?.length > 0) {
            return promotions.find(item => item?.startTime && item?.endTime && !(item?.promotionType == "8" && item?.activeType == "2"));
        }

        return null;
    }, [promotions])


    const isPreOrder = selectedProduct?.isPreOrder && selectedProduct?.promotion?.type === '11' && selectedProduct?.promotion?.enabled
	

    return <div className={classes.RightMessageContainer}>
        <BasicInformation
            selectedProduct={selectedProduct}
            selectedVariant={selectedVariant}
            productVO={productVO}
            reviewItem={reviewItem}
            promotionFlash={promotionFlash}
            serverTime={serverTime}
            showProm={showProm}
            setShowProm={setShowProm}
            estimatedPercent={estimatedPercent}
        />

        {/* {
            productVO?.discountBulletinBoard && <ProductDiscountBulletinBoard discountBulletinBoard={productVO?.discountBulletinBoard} />
        } */}


        <ProductOffInfo
            promList={promotions}
            productId={selectedProductId}
            serverTime={serverTime}
            setShowProm={setShowProm}
        />

        {/* {
            global.config.shortName === 'boutiquefeel' ? <React.Fragment>
                <ProductOffInfo
                    promList={promotions}
                    productId={selectedProductId}
                    serverTime={serverTime}
                    setShowProm={setShowProm}
                />
            </React.Fragment> : <React.Fragment>
                {
                    !promotionFlash && coupons?.length > 0 &&
                    <ProductOffInfo
                        // promList={promotions}
                        promList={coupons}
                        productId={selectedProductId}
                        serverTime={serverTime}
                        setShowProm={setShowProm}
                    />
                }
            </React.Fragment>
        } */}



        {/* <ProductActivityType selectedProduct={selectedProduct} /> */}

        <ProductAppExclusive selectedProduct={selectedProduct} />

        {
            isPreOrder && <div className={`${classes.PreOrder}`}>
                <PreOrderComponent preorder={selectedProduct?.promotion} />
            </div>
        }

        <ProductColorInformation
            productHooks={productHooks}
            changeHoverImage={(image) => changeHoverImage(image)}
            imagePrefix={imagePrefix}
        />

        {
            !isBeautyMakeup ? <ProductSizeInformation productHooks={productHooks} /> : <ProductGookToKnow productHooks={productHooks} />
        }

        {
            isFlash && selectedProduct.promotion.maxPurchasePerTimeQty > 0 && <div className={classes.PurchaseLimit}>
                <FormattedMessage id="purchase_limit" defaultMessage="Purchase limit: {qty} qty" values={{ qty: selectedProduct.promotion.maxPurchasePerTimeQty }} />
            </div>
        }

        <AddToCartContainer productHooks={productHooks} />
        <ProductShippingInfo productHooks={productHooks} />
        {
            selectedProduct?.itemFeatures && <FeatureModel productHooks={productHooks} />
        }

        {
           !selectedProduct?.itemFeatures&& <div style={{marginTop: 15}}/> 
        }

        <ProductDetailAndModel productHooks={productHooks} />
        

        {/* <SizeGuideModal /> */}
    </div>
}

export default RightMessageContainer;